/*
  hfb-likes.js — product "like" toggle. origin: hfb (task 11835). Dependency-free.
  Likes persist in this browser (localStorage) so a shopper's hearts survive page loads.
  Every button for the same product (card + PDP) stays in sync. The displayed count is the
  product's recorded like_count (data-base) plus this shopper's own like.
*/
(function () {
  'use strict';
  var KEY = 'hfb:likes';

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(ids) {
    try { window.localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) { /* private mode */ }
  }

  function paint(btn, liked) {
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    var base = parseInt(btn.getAttribute('data-base') || '0', 10) || 0;
    var n = base + (liked ? 1 : 0);
    var count = btn.querySelector('.hfb-like__count');
    if (count) {
      count.textContent = String(n);
      count.hidden = n === 0;
    }
  }

  function paintAll() {
    var liked = read();
    document.querySelectorAll('[data-hfb-like]').forEach(function (btn) {
      paint(btn, liked.indexOf(btn.getAttribute('data-hfb-like')) !== -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hfb-like]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-hfb-like');
    var liked = read();
    var i = liked.indexOf(id);
    var now = i === -1;
    if (now) liked.push(id); else liked.splice(i, 1);
    write(liked);
    document.querySelectorAll('[data-hfb-like="' + id + '"]').forEach(function (b) { paint(b, now); });
    document.dispatchEvent(new CustomEvent('hfb:like', { detail: { productId: id, liked: now } }));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintAll);
  else paintAll();
  /* Horizon swaps sections in place (variant changes, cart drawer); repaint after. */
  document.addEventListener('shopify:section:load', paintAll);
})();
